























import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import dayjs from "dayjs";
@Component({
    components: {
      
    },
})
export default class headPanel4 extends Vue { 
    public $refs: {
    };

    @Prop({
        default:false
    })
    needBack:Boolean
    created() {
    }
    mounted() {
     
        
    }
    logoutFun(){
        this.$emit('logoutFun');
    }

    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/headPanel4.vue